import React from 'react';

import LanguageRoundedIcon from '@material-ui/icons/LanguageRounded';
import GenericDetail
  from 'gui/components/listPage/components/ad/components/genericDetail';
import LinkBlock from 'gui/components/linkBlock';

import {When} from 'react-if';
import {shortUrl} from 'data/utils/shortcuts';

interface IAdWebsiteProps {
  label?: string;
  url: string;
}

const AdWebsite = (props: IAdWebsiteProps) => (
  <When condition={!!props.url}>
    {() => <GenericDetail
      title={props.label}
      icon={LanguageRoundedIcon}
    >
      <LinkBlock href={props.url}
                 style={{
                   margin: 0,
                   padding: 0,
                   display: 'inline'
                 }}>{shortUrl(props.url)}</LinkBlock>
    </GenericDetail>}
  </When>
);

AdWebsite.defaultProps = {
  label: 'קישור לאתר של העסק'
};
export default AdWebsite;
